import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 18,
	viewBox: "0 0 15 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.6364 2.76935H12.2727V1.38474C12.2727 0.623199 11.6591 0.00012207 10.9091 0.00012207H1.36364C0.613636 0.00012207 0 0.623199 0 1.38474V13.8463C0 14.6078 0.613636 15.2309 1.36364 15.2309H2.72727V16.6155C2.72727 17.377 3.34091 18.0001 4.09091 18.0001H13.6364C14.3864 18.0001 15 17.377 15 16.6155V4.15397C15 3.39243 14.3864 2.76935 13.6364 2.76935ZM2.72727 4.15397V13.8463H1.36364V1.38474H10.9091V2.76935H4.09091C3.34091 2.76935 2.72727 3.39243 2.72727 4.15397ZM13.6364 16.6155H4.09091V4.15397H13.6364V16.6155Z",
		fill: "#454545"
	})
});
export default SvgCopy;
